import type { PasskeyLinkChallenge } from "@/utils/types";
import type { RegistrationResponseJSON } from "@simplewebauthn/server";

export async function issuePasskeyLinkChallenge(): Promise<PasskeyLinkChallenge> {
  const res = await fetch("/api/auth/passkey/link/issue", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) {
    const errorText = await res.text().catch(() => "unknown_error");
    throw new Error(`Failed to issue passkey challenge (${String(res.status)}): ${errorText}`);
  }

  return (await res.json()) as PasskeyLinkChallenge;
}

export async function verifyPasskeyLink(payload: {
  challengeId: string;
  attestation: RegistrationResponseJSON;
  nickname?: string;
}): Promise<{ success: boolean }> {
  const res = await fetch("/api/auth/passkey/link/verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const errorText = await res.text().catch(() => "unknown_error");
    throw new Error(`Failed to verify passkey (${String(res.status)}): ${errorText}`);
  }

  return (await res.json()) as { success: boolean };
}

export async function removePasskey(credId: string): Promise<{ success: boolean }> {
  const res = await fetch("/api/auth/passkey/remove", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ credId }),
  });

  if (!res.ok) {
    const errorText = await res.text().catch(() => "unknown_error");
    throw new Error(`Failed to remove passkey (${String(res.status)}): ${errorText}`);
  }

  return (await res.json()) as { success: boolean };
}
